import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [megaOpen, setMegaOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2.5 group">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-pie-chart-line text-background-50 text-base"></i>
          </div>
          <span className="font-heading text-foreground-900 text-lg font-semibold whitespace-nowrap">
            OOPBUY Spreadsheet
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className="px-4 py-2 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            Startseite
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-einkaufsguide"
            className="px-4 py-2 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            Einkaufsguide
          </Link>

          <div
            className="relative"
            onMouseEnter={() => setMegaOpen(true)}
            onMouseLeave={() => setMegaOpen(false)}
          >
            <button className="px-4 py-2 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap flex items-center gap-1.5">
              Kategorien
              <i className={`ri-arrow-down-s-line text-xs transition-transform duration-200 ${megaOpen ? 'rotate-180' : ''}`}></i>
            </button>

            <div
              className={`absolute top-full left-1/2 -translate-x-1/2 mt-1 w-[720px] bg-background-50 rounded-2xl border border-background-200/70 p-5 shadow-lg transition-all duration-200 ${
                megaOpen
                  ? 'opacity-100 visible translate-y-0'
                  : 'opacity-0 invisible translate-y-2'
              }`}
              style={{ pointerEvents: megaOpen ? 'auto' : 'none' }}
            >
              <div className="grid grid-cols-2 gap-1.5">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-primary-50 transition-colors group/cat"
                  >
                    <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                      <img
                        src={cat.imageUrl}
                        alt={cat.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-foreground-900 text-sm font-medium whitespace-nowrap">{cat.name}</div>
                      <div className="text-foreground-500 text-xs whitespace-nowrap">{cat.description}</div>
                    </div>
                    <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="px-4 py-2 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            Guide
          </Link>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="ml-3 px-5 py-2 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Buy it now
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menü öffnen"
        >
          <i className={`text-foreground-800 text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-background-100 transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-home-4-line text-primary-600 text-base"></i>
              </div>
              <span className="text-foreground-800 text-sm font-medium">Startseite</span>
            </Link>

            <Link
              to="/artikel/oopbuy-spreadsheet-einkaufsguide"
              className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-background-100 transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className="ri-shopping-cart-2-line text-accent-600 text-base"></i>
              </div>
              <span className="text-foreground-800 text-sm font-medium">Einkaufsguide</span>
            </Link>

            <button
              className="w-full flex items-center justify-between px-4 py-3 rounded-xl hover:bg-background-100 transition-colors"
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className="ri-grid-line text-secondary-600 text-base"></i>
                </div>
                <span className="text-foreground-800 text-sm font-medium">Kategorien</span>
              </div>
              <i className={`ri-arrow-down-s-line text-foreground-400 text-sm transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {mobileCatOpen && (
              <div className="pl-4 space-y-0.5 pt-1 pb-1">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-background-100 transition-colors"
                  >
                    <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                      <img
                        src={cat.imageUrl}
                        alt={cat.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-foreground-800 text-sm font-medium">{cat.name}</div>
                      <div className="text-foreground-400 text-xs">{cat.description}</div>
                    </div>
                    <i className="ri-external-link-line text-foreground-400 text-xs"></i>
                  </a>
                ))}
              </div>
            )}

            <Link
              to="/artikel/oopbuy-spreadsheet-guide"
              className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-background-100 transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-guide-line text-primary-600 text-base"></i>
              </div>
              <span className="text-foreground-800 text-sm font-medium">Guide</span>
            </Link>

            <div className="pt-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-5 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors"
              >
                Buy it now
                <i className="ri-arrow-right-up-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}